import { Box, Heading, Text } from '@chakra-ui/react';
import {
	ResponsiveContainer,
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	LabelList,
} from 'recharts';

const colores = ['#3182CE', '#38A169', '#DD6B20']; // fijadas, realizadas, otras

const CustomTooltip = ({ active, payload, label }) => {
	if (!active || !payload || payload.length === 0) return null;

	const totalFijadas =
		payload.find(p => p.dataKey === 'citas_fijadas')?.value || 0;
	const totalRealizadas =
		payload.find(p => p.dataKey === 'citas_realizadas')?.value || 0;
	const totalOtras =
		payload.find(p => p.dataKey === 'citas_otras')?.value || 0;

	return (
		<Box p={2} bg='white' border='1px solid #ccc' rounded='md'>
			<Text fontWeight='bold'>{label}</Text>
			<Text>Fijadas: {totalFijadas}</Text>
			<Text>Otras: {totalOtras}</Text>
			<Text>Realizadas: {totalRealizadas}</Text>
		</Box>
	);
};

const CitasPorResponsableChart = ({ data }) => {
	const alto = Math.max(data.length * 45, 300);

	return (
		<Box
			w='100%'
			mt={4}
			borderColor='blue.400'
			rounded='lg'
			shadow='md'
			p={4}
		>
			<Heading size='md' mb={2}>
				Citas por responsable
			</Heading>
			<ResponsiveContainer width='100%' height={alto}>
				<BarChart layout='vertical' data={data}>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis type='number' />
					<YAxis dataKey='nombre' type='category' width={160} />
					<Tooltip content={<CustomTooltip />} />
					<Bar
						dataKey='citas_fijadas'
						stackId='a'
						fill={colores[0]}
					/>
					<Bar
						dataKey='citas_realizadas'
						stackId='a'
						fill={colores[1]}
					/>
					<Bar dataKey='citas_otras' stackId='a' fill={colores[2]}>
						<LabelList
							dataKey='total'
							position='right'
							// formatter={v => `${v} citas`}
						/>
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</Box>
	);
};

export default CitasPorResponsableChart;
